<template>
  <form ref="editarForm" @submit.prevent="submitEditForm">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <Select
                v-model="dado.categoria"
                inputId="categoria"
                :options="categoria"
                optionLabel="label"
                optionValue="value"
                size="small"
                appendTo="body"
                style="width: 100%"
                :invalid="campoVazio.includes('categoria')"
            />
            <label for="Categoria"><strong>Categoria: <span class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="descricao" v-model="dado.descricao" size="small" style="width: 100%"
                       :invalid="campoVazio.includes('descricao')"/>
            <label for="descricao"><strong>Descrição: <span class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="profissional" v-model="dado.profissional" size="small" style="width: 100%"
                       :invalid="campoVazio.includes('profissional')"
                       title="Nome do subcontratado ou profissional"/>
            <label for="profissional"><strong>Profissional: <span
                class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <FloatLabel variant="on">
            <Select
                v-model="dado.construcao"
                inputId="construcao"
                :options="construcoes"
                optionLabel="imovel"
                optionValue="id"
                size="small"
                appendTo="body"
                filter
                style="width: 100%"
                @update:modelValue="getConstrucaoEtapas(dado.construcao)"
            >
              <template #emptyfilter>
                Nenhum resultado encontrado
              </template>
            </Select>
            <label for="construcao">
              <strong>Construção:</strong>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <FloatLabel variant="on">
            <Select
                v-model="dado.construcao_etapa"
                inputId="construcao_etapa"
                :options="construcaoEtapas"
                :optionLabel="(etapa) => `${etapa.construcao_exibicao} - ${etapa.etapa_exibicao}`"
                optionValue="id"
                size="small"
                appendTo="body"
                filter
                style="width: 100%"
            >
              <template #emptyfilter>
                Nenhum resultado encontrado
              </template>
            </Select>
            <label for="construcao_etapa">
              <strong>Construcao Etapa:</strong>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <Select
                v-model="dado.unidade_medida"
                inputId="unidade_medida"
                :options="unidadeMedida"
                optionLabel="label"
                optionValue="value"
                size="small"
                appendTo="body"
                style="width: 100%"
                :invalid="campoVazio.includes('unidade_medida')"
            />
            <label for="unidade_medida"><strong>Unidade Medida: <span
                class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputNumber id="quantidade" v-model="dado.quantidade" size="small" style="width: 100%"
                         title="Quantidade da U.M. contratada" :invalid="campoVazio.includes('quantidade')"
                         :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"/>
            <label for="quantidade"><strong>Quantidade: <span
                class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <FloatLabel variant="on">
            <DatePicker id="data_inicio" v-model="dado.data_inicio" showIcon iconDisplay="input"
                        size="small" style="width: 100%" appendTo="body" ref="dataInicio" dateFormat="dd/mm/yyyy"
                        :invalid="campoVazio.includes('data_inicio')"/>
            <label for="data_inicio"><strong>Data Inicio: <span
                class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <DatePicker id="data_prevista_fim" v-model="dado.data_prevista_fim" showIcon iconDisplay="input"
                        size="small" style="width: 100%" appendTo="body" ref="dataPrevistaFim"
                        dateFormat="dd/mm/yyyy"
                        :invalid="campoVazio.includes('data_prevista_fim')"/>
            <label for="data_prevista_fim"><strong>Data Final Prevista: <span
                class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <FloatLabel variant="on">
            <DatePicker id="data_fim" v-model="dado.data_fim" showIcon iconDisplay="input"
                        size="small" style="width: 100%" appendTo="body" ref="dataFim" dateFormat="dd/mm/yyyy"/>
            <label for="data_fim"><strong>Data Final: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputNumber id="valor_unitario" v-model="dado.valor_unitario" size="small" style="width: 100%"
                         :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"/>
            <label for="valor_unitario"><strong>Valor Unitário: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputNumber id="valor_total" v-model="dado.valor_total" size="small" style="width: 100%"
                         :invalid="campoVazio.includes('valor_total')"
                         :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"/>
            <label for="valor_total"><strong>Valor Total: <span
                class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <Select
                v-model="dado.status_financeiro"
                inputId="status_financeiro"
                :options="statusFinanceiro"
                optionLabel="label"
                optionValue="value"
                size="small"
                appendTo="body"
                style="width: 100%"
                :invalid="campoVazio.includes('status_financeiro')"
            />
            <label for="status_financeiro">
              <strong>Status Financeiro: <span class="text-danger font-bold">*</span></strong>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <Select
                v-model="dado.status_execucao"
                inputId="status_execucao"
                :options="statusExecucao"
                optionLabel="label"
                optionValue="value"
                size="small"
                appendTo="body"
                style="width: 100%"
                :invalid="campoVazio.includes('status_execucao')"
            />
            <label for="status_execucao">
              <strong>Status Execução: <span class="text-danger font-bold">*</span></strong>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <FloatLabel variant="on">
            <Textarea id="observacao" v-model="dado.descritivo" rows="4" cols="105"/>
            <label for="observacao"><strong>Observação: </strong></label>
          </FloatLabel>
        </div>
      </div>
    </div>
    <div class="ibox-footer">
      <div class="float-right">
        <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
      </div>
      <button class="btn btn-danger font-bold" @click="$emit('fechar')">
        Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import {apiRequest, denormalizeDates} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";

export default {
  name: "EditarServico",
  props: {
    itemKey: String,
  },
  data() {
    return {
      construcoes: [],
      construcaoEtapas: [],
      dado: 1,
      erro: null,
      campoVazio: [],
      categoria: [
        {label: 'ACABAMENTO', value: 'A'},
        {label: 'SERVIÇO', value: 'S'},
      ],
      unidadeMedida: [
        {label: 'DIÁRIO', value: 'D'},
        {label: 'HORA', value: 'H'},
        {label: 'MENSAL', value: 'M'},
        {label: 'UNIDADE', value: 'U'},
      ],
      statusFinanceiro: [
        {label: 'APROVADO', value: 'A'},
        {label: 'CANCELADO', value: 'C'},
        {label: 'EM ANÁLISE', value: 'EM'},
        {label: 'PENDENTE', value: 'P'},
        {label: 'PAGO', value: 'PG'},
        {label: 'RECUSADO', value: 'R'},
      ],
      statusExecucao: [
        {label: 'CONCLUÍDO', value: 'C'},
        {label: 'EM EXECUÇÃO', value: 'EM'},
        {label: 'SUSPENSO', value: 'S'},
      ],
    }
  },
  emits: ["fechar", "atualizarDados"],
  methods: {
    async getConstrucoes() {
      const resultado = await apiRequest("GET", apiUrl.construcoes.createList);
      if (resultado.success) {
        this.construcoes = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getConstrucaoEtapas(construcaoId) {
      const resultado = await apiRequest("GET", apiUrl.construcoes.etapaCreateList(construcaoId));
      if (resultado.success) {
        this.construcaoEtapas = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.servicos.retrieveUpdateDestroy(this.itemKey)}?modo=edit`);
      if (resultado.success) {
        this.dado = resultado.data;
        if (this.dado.construcao) {
          await this.getConstrucaoEtapas(this.dado.construcao);
        }
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitEditForm() {
      denormalizeDates(this.dado, ['data_inicio', 'data_prevista_fim', 'data_fim']);
      const resultado = await apiRequest("PATCH", `${apiUrl.servicos.retrieveUpdateDestroy(this.itemKey)}?modo=edit`, this.dado);
      if (resultado.success) {
        this.$emit("atualizarDados", resultado.data);
        this.$toastMessage("success", "Registro alterado com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getDados();
    this.getConstrucoes();
    Inputmask("99/99/9999").mask(this.$refs.dataInicio.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.dataPrevistaFim.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.dataFim.$el.querySelector("input"));
  },
}
</script>
